import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=01860b36&scoped=true&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"
import style0 from "./sso.vue?vue&type=style&index=0&id=01860b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01860b36",
  null
  
)

export default component.exports